import Dater from '../../../services/DateFormat'
import getReports from '../../../services/http/Relatorios'
import getReportsXls from '../../../services/http/RelatoriosXls'

const generateReport = async ({
  ano = Dater().formatar(new Date(), 'yyyy'),
  biblioteca = 1
}) => {
  const response = await getReports(
    'gestao-leitura',
    `ano_ref=${ano}&biblioteca_id=${biblioteca}`
  )
  const file = new Blob([response.data], {
    type: 'application/pdf'
  })
  const fileUrl = URL.createObjectURL(file)

  window.open(fileUrl)
}

const generateEmprestimoReport = async ({
  ano = Dater().formatar(new Date(), 'yyyy'),
  biblioteca = 1
}) => {
  const response = await getReports(
    'gestao-leitura/livros-em-emprestimo',
    `ano=${ano}&biblioteca_id=${biblioteca}`
  )
  const file = new Blob([response.data], {
    type: 'application/pdf'
  })
  const fileUrl = URL.createObjectURL(file)

  window.open(fileUrl)
}

async function getColaboratorsWithoutPosted({
  ano = Dater().formatar(new Date(), 'yyyy'),
  biblioteca = 1,
  mes = Dater().formatar(new Date(), 'mm')
}) {
  const response = await getReports(
    'gestao-leitura/ausencia-leituras',
    `mes=${mes}&ano=${ano}&biblioteca_id=${biblioteca}`
  )
  const file = new Blob([response.data], {
    type: 'application/pdf'
  })
  const fileUrl = URL.createObjectURL(file)

  window.open(fileUrl)
}

const generateAcervoReport = async ({
  // ano = Dater().formatar(new Date(), 'yyyy'),
  biblioteca = 1,
  formato = undefined
}) => {
  const formatEx =
    formato === undefined ? '' : `&formato_exemplar_id=${formato}`
  const response = await getReports(
    'gestao-leitura/acervo-obras',
    `biblioteca_id=${biblioteca}${formatEx}`
  )
  const file = new Blob([response.data], {
    type: 'application/pdf'
  })
  const fileUrl = URL.createObjectURL(file)

  window.open(fileUrl)
}

const acervoReportXls = async ({
  // ano = Dater().formatar(new Date(), 'yyyy'),
  biblioteca = 1,
  formato = undefined
}) => {
  const response = await getReportsXls(
    `biblioteca_id=${biblioteca}&formato_exemplar_id=${formato}`
  )
  const file = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  })
  const fileUrl = URL.createObjectURL(file)

  window.open(fileUrl)
}

export {
  generateReport,
  generateEmprestimoReport,
  generateAcervoReport,
  acervoReportXls,
  getColaboratorsWithoutPosted
}
